
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctCorner as ObiDuctCornerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-corner.js';
 
 
 

 
 export const ObiDuctCorner = createComponent({
   react: React,
   tagName: 'obi-duct-corner',
   elementClass: ObiDuctCornerElement,
   events: {
     
   }
  });
 
 